const scrollTop = () => {
    if(document.querySelector('.main-content__top')){
        window.onscroll = () => {

            if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
                document.querySelector('.main-content__top').classList.add('main-content__top-show');


            } else {
                if (document.querySelector('.main-content__top').classList.contains("main-content__top-show")) {
                    document.querySelector('.main-content__top').classList.remove("main-content__top-show");
                }
            }
        }
    }

}

export default scrollTop;